import { useEffect, useState, useContext } from "react";
import { format, parseISO, addDays } from "date-fns";
import { AuthContext } from "../AuthContext";
import { Switch } from '@headlessui/react'
import { ArrowPathRoundedSquareIcon, CheckBadgeIcon, ExclamationCircleIcon, SwatchIcon, UserCircleIcon } from "@heroicons/react/20/solid";
import LoadingComponent from "./loading";


export default function OverTimeRequests({ shifts, budgetTableData }) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);
    const [report, setReport] = useState([]);
    const [message, setMessage] = useState(false);
    const [recommendations, setRecommendations] = useState([]);
    const [budgetRemaining, setBudgetRemaining] = useState(null);
    

    console.log("Report:", budgetTableData);
    console.log("shifts:", shifts);

  // false: show Not Approved; true: show Approved requests.
  const [approvedFilter, setApprovedFilter] = useState(false);
  // Selected date in "yyyy-MM-dd" format. Default is today.
  const [selectedDate, setSelectedDate] = useState(format(new Date(), "yyyy-MM-dd"));
  // Store selected amend hours for each request by request id.
  const [amendHours, setAmendHours] = useState({});

  const user = useContext(AuthContext);
  
  // Compute the next 7 days (including today) as an array of date strings.
  const next7Days = Array.from({ length: 7 }, (_, i) =>
    format(addDays(new Date(), i), "yyyy-MM-dd")
  );

  // Fetch requests from the API and filter by approved status.
  const fetchMessages = async () => {
    try {
      const response = await fetch("https://api.insightos.co.uk/api/overtimerequests", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

      });
      if (!response.ok) throw new Error("Failed to fetch messages");
      const data = await response.json();
      console.log("Messages:", data);

      // Filter requests based on approved filter.
      const filtered = data.data.filter((request) =>
        approvedFilter === 0
          ? request.Approved === 0 // Not Approved
          : approvedFilter === 1
          ? request.Approved === 1 // Approved
          : request.Approved === 2 // Accepted
      );
      
      console.log(filtered)

      // For each request, calculate overtime details.
      const updatedRequests = filtered.map((request) => {
        const calc = handleCalculate(request.OvertimeDate, request.Hours, request.Role);
        return {
          ...request,
          overtimeCalculation: calc,
        };
      });

      console.log("Updated Requests:", updatedRequests);
      setRequests(updatedRequests);
    } catch (error) {
      console.error("Failed to fetch messages:", error);
    }
    setLoading(false);
  };


  useEffect(() => {
    // Ensure that shifts and budgetTableData exist before fetching.
    console.log("called")
    fetchMessages();

    // refresh every 60 seconds
    const interval = setInterval(fetchMessages, 60000);
    return () => clearInterval(interval);

  }, [shifts, budgetTableData, approvedFilter]);


  const parseReport = (reportStr) => {
    // Trim the input to remove any accidental whitespace issues
    reportStr = reportStr.trim();
    
    // Fix any encoding issues for the pound sign, if needed
    reportStr = reportStr.replace(/┬ú/g, '£');
    
    // Regex to match each recommendation line.
    // This regex expects exactly:
    // Role - Hours - Reason - Staff: StaffName - Cost: £OvertimeCost - Tasks: OutstandingTasks - Id: RequestId
    const recommendationRegex = /^(.+?) - (\d+) - (.+?) - Staff:\s*(.+?)\s*-\s*Cost:\s*£(\d+(?:\.\d+)?) - Tasks:\s*(.+?)\s*-\s*Id:\s*(.+)$/gm;
    const recommendations = [];
    let match;
    
    // Extract recommendations
    while ((match = recommendationRegex.exec(reportStr)) !== null) {
      recommendations.push({
        Role: match[1].trim(),
        Hours: parseInt(match[2], 10),
        Reason: match[3].trim(),
        Staff: match[4].trim(),
        Cost: parseFloat(match[5]),
        Tasks: match[6].trim(),
        Id: match[7].trim(),
      });
    }
    
    // Extract the "Budget Remaining" value separately
    const budgetRegex = /Budget Remaining:\s*£(-?\d+(?:\.\d+)?)/;
    const budgetMatch = reportStr.match(budgetRegex);
    const budgetRemaining = budgetMatch ? parseFloat(budgetMatch[1]) : null;
    
    console.log("Parsed Recommendations:", recommendations);
    console.log("Budget Remaining:", budgetRemaining);
    
    return { recommendations, budgetRemaining };
  };
  

  // now we want to work out the cost remaining for the dates in use shifts and budgetTableData updatedRequests

 





  
  console.log(amendHours);

  
  // Example usage inside your compareRequests function:
  const compareRequests = async () => {
    console.log("Comparing requests for", selectedDate);
    console.log("Requests for selected date:", requestsForSelectedDate);

    setLoading(true);

    // Remove requests where AdminRejected is 1
    const removeRejected = requestsForSelectedDate.filter((request) => request.AdminRejected !== 1);

    // If amended hours exist, update the requests; otherwise, keep them unchanged
   

    try {
      const response = await fetch("https://api.insightos.co.uk/api/overtimerequests", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',

        body: JSON.stringify({ 
          requests: removeRejected, 
          selectedDate 
        }),
      });

      if (!response.ok) throw new Error("Failed to compare requests");

      const data = await response.json();
      console.log("Comparison Report:", data.report);

      // Parse the report using the regex function
      const { recommendations, budgetRemaining } = parseReport(data.report);
      console.log("Parsed Recommendations:", recommendations);
      console.log("Budget Remaining:", budgetRemaining);

      setRecommendations(recommendations);


      setReport(data.report);
      setLoading(false);

    } catch (error) {
      console.error("Failed to compare requests:", error);
      setLoading(false);
    }
};

  




 


  
const handleApprove = async (rec) => {
  console.log("Approving Request:", rec);

  // Override Hours if amended
  const updatedRec = {
      ...rec,
      Hours: amendHours[rec.Id] ? parseInt(amendHours[rec.Id], 10) : rec.Hours,
  };

  try {
      const response = await fetch("https://api.insightos.co.uk/api/invite", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          credentials: 'include',

          body: JSON.stringify(updatedRec), // Send the updated object
      });

      if (!response.ok) throw new Error("Failed to approve request");

      const data = await response.json();

      console.log("Approved Request:", updatedRec);
      setMessage("Request Approved");

      // Remove approved request from recommendations
      setRecommendations((prevRecs) => prevRecs.filter((r) => r.Id !== rec.Id));

      fetchMessages();
  } catch (error) {
      console.error("Failed to approve request:", error);
  }
};

// we want a useEffect to see when recommendations change and the length is 0 then we want to setReport to an empty string

useEffect(() => {
  if (recommendations.length === 0) {
      setReport("");
  }
}, [recommendations]);



  // Calculate overtime details.
  const handleCalculate = (overtimeDateISO, requestedHours, role) => {
    console.log("Calculating Overtime for:", overtimeDateISO, requestedHours, role);
    const dateObj = parseISO(overtimeDateISO);
    const formattedDate = format(dateObj, "yyyy-MM-dd");
    const dayOfWeek = format(dateObj, "EEEE");
    console.log("Day of the week:", dayOfWeek);

    const shiftsForDate = shifts.filter((shift) => {
      const shiftDate = format(new Date(shift.ShiftDate), "yyyy-MM-dd");
      return shiftDate === formattedDate;
    });

    if (shiftsForDate.length === 0) {
      console.log(`No shifts found for any role on ${formattedDate}`);
      return { remainingBudget: 0, totalOvertimeCost: 0, availableOvertimeHours: 0, exceedsBudget: false, overBudgetBy: 0 };
    }

    const shiftsForRole = shiftsForDate.filter((shift) => shift.staff.Role === role);
    if (shiftsForRole.length === 0) {
      console.log(`No shifts found for role ${role} on ${formattedDate}`);
      return { remainingBudget: 0, totalOvertimeCost: 0, availableOvertimeHours: 0, exceedsBudget: false, overBudgetBy: 0 };
    }

    let totalWorkedCost = 0;
    shiftsForDate.forEach((shift) => {
      const start = new Date(`1970-01-01T${shift.StartTime}Z`);
      const end = new Date(`1970-01-01T${shift.EndTime}Z`);
      const shiftDuration = (end - start) / (1000 * 60 * 60);
      const rate = parseFloat(shift.staff.HourlyRate);
      if (!isNaN(shiftDuration) && !isNaN(rate)) {
        totalWorkedCost += shiftDuration * rate;
      }
    });
    console.log(`Total cost of hours worked on ${formattedDate}: £${totalWorkedCost.toFixed(2)}`);

    // budgetTableData is now just a number (total budget)
    const dailyBudget = typeof budgetTableData === "number" ? budgetTableData : 0;
    console.log(`Daily Budget: £${dailyBudget.toFixed(2)}`);

    const remainingBudget = dailyBudget - totalWorkedCost;
    console.log(`Remaining Budget for overtime: £${remainingBudget.toFixed(2)}`);

    const hourlyRate = parseFloat(shiftsForRole[0].staff.HourlyRate);
    const requestedOvertimeCost = parseFloat(requestedHours) * hourlyRate;
    console.log(`Requested Overtime Cost: £${requestedOvertimeCost.toFixed(2)}`);

    const availableOvertimeHours = remainingBudget / hourlyRate;
    console.log(`Available overtime hours within budget: ${availableOvertimeHours.toFixed(2)} hours`);

    const exceedsBudget = requestedOvertimeCost > remainingBudget;
    console.log(`Exceeds Budget: ${exceedsBudget}`);
    const overBudgetBy = requestedOvertimeCost - remainingBudget;

    return {
      totalOvertimeCost: requestedOvertimeCost,
      remainingBudget,
      availableOvertimeHours,
      exceedsBudget,
      overBudgetBy,
      hourlyRate,
    };
  };

  // Filter requests by selected date and exclude rejected ones for processing logic
  const requestsForSelectedDate = requests.filter((request) => {
    const reqDate = format(parseISO(request.OvertimeDate), "yyyy-MM-dd");
    return reqDate === selectedDate;
  });

  // Get non-rejected requests for processing logic
  const nonRejectedRequestsForDate = requestsForSelectedDate.filter(request => 
    request.AdminRejected !== 1
  );

  // Show the Compare button if more than one non-rejected request exists for the selected date.
  const showCompareButton = nonRejectedRequestsForDate.length > 1 

  // Show process button for individual requests awaiting approval (status 0, not rejected)
  const requestsAwaitingApproval = nonRejectedRequestsForDate.filter(req => req.Approved === 0)
  const showProcessButton = requestsAwaitingApproval.length >= 1

  const showApproveButton = requestsForSelectedDate.length === 5

  // Toggle between Approved and Not Approved.
  const handleToggleApproved = () => {
    setApprovedFilter((prev) => (prev + 1) % 3); // Cycles through 0, 1, and 2 (Not Approved, Approved, Accepted)
  };
  

  // Update the amend hours selection for a given request.
 const handleAmendHoursChange = (recId, newHours) => {
  setAmendHours((prev) => ({
    ...prev,
    [recId]: newHours, // Store updated hours by request ID
  }));
  };

  // Placeholder for handling an amended request.

  


  // Placeholder for handling acceptance.
  const handleSaveAcceptance = async (requestId, number) => {

    console.log("Accepting Request:", requestId);

    try {
        const response = await fetch("https://api.insightos.co.uk/api/inviterequest", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include',

            body: JSON.stringify({ requestId, number }),
        });

        if (!response.ok) throw new Error("Failed to accept request");

        const data = await response.json();
        console.log("Accepted Request:", data);

        // remove the request from the list



        fetchMessages();

    } catch (error) {

        console.error("Failed to accept request:", error);

    }




    
    // Your acceptance logic here.
  };


  const acceptOvertime = async (overtimeId) => {
    try {
      const response = await fetch(`https://api.insightos.co.uk/api/acceptovertime`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',
        body: JSON.stringify({ overtimeId })
      });

      if (!response.ok) throw new Error('Failed to accept overtime');

        // call mark as read

        fetchMessages();



   

    } catch (error) {
      console.error(error);
    }
  };

  const handleAdminReject = async (requestId) => {

    try {

        const response = await fetch("https://api.insightos.co.uk/api/adminreject", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include',

            body: JSON.stringify({ requestId }),
        });

        if (!response.ok) throw new Error("Failed to reject request");

        const data = await response.json();
        console.log("Rejected Request:", data);

        // remove the request from the list

        fetchMessages();

    } catch (error) {

        console.error("Failed to reject request:", error);

    }

};




    const handleReject = async (requestId) => {
    try {
      const response = await fetch("https://api.insightos.co.uk/api/reject", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials : 'include',

        body: JSON.stringify({ requestId })
        });

        if (!response.ok) throw new Error('Failed to reject request');

        const data = await response.json();

        console.log("Rejected Request:", data);

        // remove the request from the list

        fetchMessages();

    } catch (error) {
        console.error(error);
        }

    };







  return (
    <div className="mt-5 rounded-3xl border border-white/30 bg-white/10 px-2 py-3 backdrop-blur-xl sm:px-4 lg:px-6">
        {loading && <LoadingComponent />}
      {/* Approved Toggle */}
      <div className="mb-4 flex flex-col items-start gap-3 rounded-2xl border border-white/20 bg-white/12 p-3 shadow-[0_12px_30px_rgba(15,23,42,0.2)] backdrop-blur-xl sm:flex-row sm:items-center sm:gap-4">
        
        
        <div className="flex items-center">
          <label className="mr-2 font-semibold text-sm sm:text-base">Show Approved:</label>
          <button
            onClick={handleToggleApproved}
            data-component="overtime-requests-filters"
            data-feature="cycle_request_filter_get"
            className={`rounded-2xl px-3 py-1.5 text-xs sm:text-sm font-medium shadow-[0_10px_24px_rgba(15,23,42,0.22)] ${
              approvedFilter === 0
                ? "bg-red-500 text-white" // Not Approved
                : approvedFilter === 1
                ? "bg-indigo-600 text-white" // Approved
                : "bg-emerald-500 text-white" // Accepted
            }`}
          >
            {approvedFilter === 0
              ? "Showing Not Approved"
              : approvedFilter === 1
              ? "Showing Approved"
              : "Showing Accepted"}
          </button>
        </div>

        {(showCompareButton || showProcessButton) && user.access === "admin" && (
        <div className="flex flex-col sm:flex-row gap-2">
          {showCompareButton && (
            <button onClick={compareRequests}
            type="button"
            data-component="overtime-requests-actions"
            data-time-saved="10"
            data-feature="compare_requests_post"
            className="inline-flex items-center gap-x-2 rounded-2xl bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-3 py-2 text-xs font-semibold text-white shadow-[0_12px_28px_rgba(49,46,129,0.3)] transition-all hover:from-indigo-800/95 hover:to-indigo-600/95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:px-3.5 sm:py-2.5 sm:text-sm"
          >
            Compare Requests ({nonRejectedRequestsForDate.length})
            <ArrowPathRoundedSquareIcon aria-hidden="true" className="-mr-0.5 size-4 sm:size-5" />
          </button>
          )}
          
          {showProcessButton && !showCompareButton && (
            <button onClick={compareRequests}
            type="button"
            data-component="overtime-requests-actions"
            data-time-saved="45"
            data-feature="process_single_request_post"
            className="inline-flex items-center gap-x-2 rounded-2xl bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 px-3 py-2 text-xs font-semibold text-white shadow-[0_12px_28px_rgba(5,150,105,0.28)] transition-all hover:from-emerald-600/95 hover:to-emerald-400/95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 sm:px-3.5 sm:py-2.5 sm:text-sm"
          >
            Process Request ({requestsAwaitingApproval.length})
            <CheckBadgeIcon aria-hidden="true" className="-mr-0.5 size-4 sm:size-5" />
          </button>
          )}
        </div>
        )}
      </div>

      {/* Tabs for Next 7 Days */}
      <div className="mb-4 flex flex-wrap gap-1 rounded-2xl border border-white/25 bg-white/10 p-2 shadow-[0_10px_26px_rgba(15,23,42,0.2)] backdrop-blur-xl sm:gap-2">
        {next7Days.map((dateStr) => (
          <button
            key={dateStr}
            onClick={() => setSelectedDate(dateStr)}
            className={`rounded-2xl px-2 py-1.5 text-xs font-semibold shadow-[0_8px_20px_rgba(15,23,42,0.2)] transition-colors hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:px-3 sm:py-2 sm:text-sm ${
              selectedDate === dateStr ? "bg-white/20 text-white border border-white/30" : "bg-white/80 text-gray-800"
            }`}
          >
            <span className="hidden sm:inline">{format(parseISO(dateStr), "EEE, MMM d")}</span>
            <span className="sm:hidden">{format(parseISO(dateStr), "EEE")}</span>
          </button>
        ))}
      </div>

{message && (
        <div className="mb-4 rounded-2xl border border-emerald-300/40 bg-emerald-500/85 p-3 text-white shadow-[0_10px_24px_rgba(5,150,105,0.25)] sm:p-4">
            <p className="text-sm sm:text-base">{message}</p>
        </div>
    )}



      {report.length > 0 && (() => {
  return (
    <div className="mb-4 rounded-2xl border border-white/35 bg-white/80 p-3 shadow-[0_14px_35px_rgba(15,23,42,0.16)] backdrop-blur-xl sm:p-4">
      <h2 className="text-lg sm:text-xl font-semibold mb-4">Comparison Report</h2>
      
      {/* Mobile-first responsive table */}
      <div className="overflow-x-auto">
        <div className="min-w-full divide-y divide-gray-300">
          {/* Desktop Table */}
          <div className="hidden lg:block">
            <table className="min-w-full divide-y divide-slate-200">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Role
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Hours</th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Reason</th>
                  <th scope="col" className="py-3.5 pl-3 pr-4 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Staff
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Cost</th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Tasks</th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200 bg-white/90">
                {recommendations.map((rec, index) => (
                  <tr key={index} className="text-gray-800 border-t">
                    <td className="py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{rec.Role}</td>
                    <td className="px-3 py-4 text-sm text-gray-500">
                      <div className="flex items-center space-x-2">
                        {rec.Hours}
                        <select 
                          onChange={(e) => handleAmendHoursChange(rec.Id, e.target.value)} 
                          value={amendHours[rec.Id] || ""}
                          className="ml-2 rounded-xl border border-indigo-300 bg-white px-2 py-1 text-xs text-indigo-700 shadow-sm"
                        >
                          <option value="" disabled>Select Hours</option>
                          <option value="1">1 Hour</option>
                          <option value="2">2 Hours</option>
                          <option value="3">3 Hours</option>
                          <option value="4">4 Hours</option>
                        </select>
                      </div>
                    </td>
                    <td className="px-3 py-4 text-sm text-gray-500">{rec.Reason}</td>
                    <td className="px-3 py-4 text-sm text-gray-500">{rec.Staff}</td>
                    <td className="px-3 py-4 text-sm text-gray-500">£{rec.Cost}</td>
                    <td className="px-3 py-4 text-sm text-gray-500">{rec.Tasks}</td>
                    <td className="px-3 py-4 text-sm text-gray-500">
                      <div className="space-y-2">
                        <button
                          onClick={() => handleApprove(rec)}
                          data-component="overtime-recommendations"
                          data-time-saved="10"
                          data-feature="approve_recommendation_post"
                          className="block w-full rounded-xl bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 px-3 py-1 text-xs text-white shadow-[0_8px_20px_rgba(5,150,105,0.22)] hover:from-emerald-600/95 hover:to-emerald-400/95"
                        >
                          Approve
                        </button>
                        <button 
                          onClick={() => handleAdminReject(rec.Id)}
                          data-component="overtime-recommendations"
                          data-feature="reject_recommendation_post"
                          className="block w-full rounded-xl bg-gradient-to-br from-red-700/90 to-red-500/90 px-3 py-1 text-xs text-white shadow-[0_8px_20px_rgba(239,68,68,0.22)] hover:from-red-600/95 hover:to-red-400/95"
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="lg:hidden space-y-4">
            {recommendations.map((rec, index) => (
              <div key={index} className="rounded-2xl border border-white/35 bg-white/90 p-4 shadow-[0_10px_24px_rgba(15,23,42,0.14)] backdrop-blur-xl">
                <div className="space-y-3">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-sm font-semibold text-gray-900">{rec.Role}</h3>
                      <p className="text-xs text-gray-600">{rec.Staff}</p>
                    </div>
                    <span className="text-sm font-medium text-green-600">£{rec.Cost}</span>
                  </div>
                  
                  <div className="text-xs text-gray-600">
                    <p><span className="font-medium">Reason:</span> {rec.Reason}</p>
                    <p><span className="font-medium">Tasks:</span> {rec.Tasks}</p>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm">Hours: {rec.Hours}</span>
                      <select 
                        onChange={(e) => handleAmendHoursChange(rec.Id, e.target.value)} 
                        value={amendHours[rec.Id] || ""}
                        className="rounded-xl border border-indigo-300 bg-white px-2 py-1 text-xs text-indigo-700 shadow-sm"
                      >
                        <option value="" disabled>Amend</option>
                        <option value="1">1 Hour</option>
                        <option value="2">2 Hours</option>
                        <option value="3">3 Hours</option>
                        <option value="4">4 Hours</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleApprove(rec)}
                      data-component="overtime-recommendations"
                      data-time-saved="10"
                      data-feature="approve_recommendation_post"
                      className="flex-1 rounded-xl bg-gradient-to-br from-emerald-700/90 to-emerald-500/90 px-3 py-2 text-sm font-medium text-white shadow-[0_8px_20px_rgba(5,150,105,0.22)] hover:from-emerald-600/95 hover:to-emerald-400/95"
                    >
                      Approve
                    </button>
                    <button 
                      onClick={() => handleAdminReject(rec.Id)}
                      data-component="overtime-recommendations"
                      data-feature="reject_recommendation_post"
                      className="flex-1 rounded-xl bg-gradient-to-br from-red-700/90 to-red-500/90 px-3 py-2 text-sm font-medium text-white shadow-[0_8px_20px_rgba(239,68,68,0.22)] hover:from-red-600/95 hover:to-red-400/95"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {budgetRemaining !== null && (
        <div className="mt-4 rounded-2xl border border-white/35 bg-white/85 p-3 shadow-[0_10px_24px_rgba(15,23,42,0.12)] backdrop-blur-xl">
          <div className="text-sm sm:text-base font-semibold text-gray-800">
            Budget Remaining: £{budgetRemaining}
          </div>
        </div>
      )}
    </div>
  );
})()}


     

      {/* Request Cards */}
      <div className="grid grid-cols-1 gap-3 sm:gap-4">
        {requestsForSelectedDate.map((request, index) => {
         const isApproved = request.Approved === 1;
         const isComplete = request.Approved === 2;
         const isProcess = request.Approved === 0;
         const isRejected = request.AdminRejected === 1 && request.Approved === 0;
         
         return (
           <div
             key={index}
             className={`relative flex flex-col space-y-3 rounded-2xl border border-white/35 px-4 sm:px-6 py-4 sm:py-5 shadow-[0_14px_35px_rgba(15,23,42,0.18)] backdrop-blur-xl 
               focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:border-gray-400
               ${isRejected ? "bg-red-500" : isComplete ? "bg-emerald-500" : isApproved ? "bg-indigo-600" : isProcess ? "bg-orange-500" : ""}`}
           >
            
                {request.Approved === 0 && (
                <div className="absolute top-2 right-2 p-1.5 sm:p-2 bg-white rounded-bl-lg rounded-tr-lg">
                    <ExclamationCircleIcon className="h-4 w-4 sm:h-6 sm:w-6 text-red-500" aria-hidden="true" />
                    {isRejected && (
                    <p className="text-xs font-semibold text-red-500">Admin Rejected</p>
                    )}
                    {!isRejected && (
                    <p className="text-xs font-semibold text-red-500">Awaiting Approval</p>
                    )}
                </div>
                )}
                {request.Approved === 1 && (
                <div className="absolute top-2 right-2 p-1.5 sm:p-2 bg-white rounded-bl-lg rounded-tr-lg">
                    <CheckBadgeIcon className="h-4 w-4 sm:h-6 sm:w-6 text-emerald-500" aria-hidden="true" />
                    <p className="text-xs font-semibold text-emerald-500">Admin Approved</p>
                </div>
                )}
                {request.Approved === 2 && (
                <div className="absolute top-2 right-2 p-1.5 sm:p-2 bg-white rounded-bl-lg rounded-tr-lg">
                    <UserCircleIcon className="h-4 w-4 sm:h-6 sm:w-6 text-emerald-500" aria-hidden="true" />
                    <p className="text-xs font-semibold text-emerald-500">Complete</p>
                </div>
                )}

              <div className="flex-1 pr-12 sm:pr-16">

                <p className="text-xs font-medium text-white">{request.Department}</p>
                <p className="text-sm font-bold text-white">Role: {request.Role}</p>
                <p className="text-sm text-white">{request.Reason}</p>
                <p className="text-sm text-white">{request.Hours} hours</p>
                {isComplete && (
                    <div className="flex-col items-center">
                  <p className="text-sm text-white">Total Cost: £{request.overtimeCalculation.totalOvertimeCost.toFixed(2)}</p>
                  <p className="text-sm font-semi-bold text-white">{request.Staff}</p>
                    </div>
                )}

                <p className="truncate text-sm text-white">
                  {format(parseISO(request.OvertimeDate), "EEEE, MMMM d, yyyy")}
                </p>
                <p className="text-sm text-white mt-5">
                  Created At: {format(parseISO(request.CreatedAt), "dd-MM-yyyy")}
                </p>
              </div>
           
{(user.access === "admin" && isApproved || (user.department === request.Department && isApproved)) && (
                    <div className="p-3 sm:p-4 bg-white rounded-md">
                                                {request.Staff !== user.name && (

                        <div >
                        <p className="text-xs font-medium text-indigo-600"> AI Recommended Staff Member  : {request.Staff}</p>
                        <p className="text-xs font-medium text-indigo-600"> Hours Allocated : {request.Hours}</p>
                        <p className="text-xs font-medium text-indigo-600"> Tasks: {request.Tasks}</p>
                        {request.Accepted === null && (
                            <p className="text-xs font-medium text-red-600"> Status: Awaiting Invitation</p>
                        )}
                        {request.Accepted === 1 && (
                            <p className="text-xs font-medium text-indigo-600"> Status: Awaiting Response</p>
                        )}
                        {request.Accepted === 2 && (
                            <p className="text-xs font-medium text-emerald-600"> Status: Accepted</p>
                        )}
                        {request.Accepted === 3 && (
                            <>
                            <p className="text-xs font-medium text-red-600"> Status: Rejected</p>
                            <p className="text-xs font-medium text-red-600"> Staff: {request.StaffRejected}</p>
                            <h3 className="text-lg font-medium text-emerald-600"> Out For Bids</h3>
                            </>
                            
                        )}
                       
                <button
                  onClick={() => handleSaveAcceptance(request.id, 1)}
                  type="button"
                  className="mt-4 w-full rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm 
                    hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-300"
                >

                    Invite Recommended Staff
                </button>
                <button onClick={() => handleSaveAcceptance(request.id, 2 )}
                type="button"
                className="mt-4 w-full rounded-md bg-fuchsia-600 px-4 py-2 text-sm font-semibold text-white shadow-sm 
                    hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-300"
                >
                    Invite Team 
                </button>

                    </div>
                    )}
{
  request.Staff && request.Staff.split(',').includes(user.name) && request.Approved === 1 && (                      <div>
                        <p className="text-xs font-medium text-indigo-600"> You have been recommended for this request</p>
                        <p className="text-xs font-medium text-indigo-600"> Hours Allocated : {request.Hours}</p>
                        <p className="text-xs font-medium text-indigo-600"> Tasks: {request.Tasks}</p>
                        {request.Accepted === null && (
                            <p className="text-xs font-medium text-red-600"> Status: Awaiting Invitation</p>
                        )}
                        {request.Accepted === 1 && (
                            <p className="text-xs font-medium text-indigo-600"> Status: Awaiting Response</p>
                        )}
                        {request.Accepted === 2 && (
                            <p className="text-xs font-medium text-emerald-600"> Status: Accepted</p>
                        )}
                        {request.Accepted === 3 && (
                        <>
                            <p className="text-xs font-medium text-red-600"> Status: Rejected</p>
                            <p className="text-xs font-medium text-red-600"> Staff: {request.StaffRejected}</p>
                            <h3 className="text-lg font-medium text-emerald-600"> Out For Bids</h3>

                            </>
                        )}
                            
                            {request.StaffRejected !== user.name && (
                                <>
                        <button onClick={() => acceptOvertime(request.id)}
                        type="button"
                        className="mt-4 w-full rounded-md bg-fuchsia-600 px-4 py-2 text-sm font-semibold text-white shadow-sm 
                            hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-300"
                        >
                           Accept Request
                        </button>
                        <button onClick={() => handleReject(request.id )}
                        type="button"
                        className="mt-4 w-full rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm 
                            hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-300"
                        >
                            Reject Request
                        </button>
                        </>
                            )}
                        


                        </div>
                    )}




                  
                </div>
                )}
                


              {user.access === "admin" && !isComplete && !isApproved && !isRejected && (
                                <div className="mt-4 w-full flex flex-col space-y-2">
                  <button
                    onClick={() => handleAdminReject(request.id)}
                    type="button"
                    className="w-full rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm
                    hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-300"
                  >
                    Reject Request
                  </button>
                  
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
